import React from "react";
import { Card, CardContent } from "./ui/card";
import { Quote } from "lucide-react";
import { mockData } from "../mock";

const TrustProofSection = () => {
  const { trustProof } = mockData;

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        {/* Clean Header - Welcome.com Style */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Trusted by
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-orange-600"> 
              {" "}Industry Leaders
            </span>
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto mb-8 leading-relaxed font-medium">
            Organizations worldwide trust CNESS to guide their sustainability transformation
          </p>
          
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-orange-500 mx-auto rounded-full"></div>
        </div>

        {/* Professional Organizations Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 items-center justify-center mb-16 max-w-5xl mx-auto">
          {[
            { name: "Fortune 500", color: "from-blue-500 to-blue-600" },
            { name: "Global 2000", color: "from-purple-500 to-purple-600" },
            { name: "Enterprises", color: "from-green-500 to-green-600" },
            { name: "Startups", color: "from-orange-500 to-orange-600" },
            { name: "NGOs", color: "from-teal-500 to-teal-600" },
            { name: "Social Impact", color: "from-indigo-500 to-indigo-600" }
          ].map((org, i) => (
            <div key={i} className="group cursor-pointer">
              <div className="flex flex-col items-center justify-center h-20 bg-gray-50 hover:bg-white rounded-xl hover:shadow-md transition-all duration-300 border border-gray-100">
                <div className={`w-10 h-10 bg-gradient-to-r ${org.color} rounded-lg mb-2 flex items-center justify-center shadow-sm`}>
                  <div className="w-5 h-5 bg-white/30 rounded-sm" />
                </div>
                <span className="text-xs font-semibold text-gray-700">{org.name}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Testimonial Section */}
        <div className="max-w-4xl mx-auto mb-16">
          <Card className="border-0 bg-gradient-to-r from-gray-50 to-gray-100/50 shadow-sm">
            <CardContent className="p-10 text-center">
              <Quote className="h-10 w-10 text-amber-500 mx-auto mb-6" />
              
              <blockquote className="text-xl md:text-2xl font-medium text-gray-900 leading-relaxed">
                "CNESS has transformed how we approach sustainability. The framework is comprehensive yet practical, and the results are measurable."
              </blockquote>
            </CardContent>
          </Card>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto text-center">
          <div className="p-6">
            <div className="text-4xl font-bold text-amber-600 mb-2">98%</div>
            <p className="text-gray-600 font-medium">Client Satisfaction Rate</p>
          </div>
          <div className="p-6">
            <div className="text-4xl font-bold text-orange-600 mb-2">500+</div>
            <p className="text-gray-600 font-medium">Organizations Certified</p>
          </div>
          <div className="p-6">
            <div className="text-4xl font-bold text-amber-600 mb-2">30+</div>
            <p className="text-gray-600 font-medium">Countries Represented</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustProofSection;